import { memo } from "react";
import { useTranslation } from "react-i18next";
import IdentifierDot from "./IdentifierDot";
import { ConversationType } from "../../enums/ConversationType";

const ConversationIdentifier = memo(() => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-4 items-center ml-3">
      <IdentifierDot conversationType={ConversationType.CLIENTS} />
      <span>{t("CLIENT") }</span>

      <IdentifierDot conversationType={ConversationType.LEADS} />
      <span>{t("LEAD") }</span>

      <IdentifierDot conversationType={ConversationType.OTHER} />
      <span>{t("NO_CLIENT") }</span>
    </div>
  );
});

export default ConversationIdentifier;
